var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"track-button",on:{"click":function (e) { return _vm.$emit('custom-event', _vm.item, e); }}},[_vm._v("\n  click me\n")])}
var staticRenderFns = []

export { render, staticRenderFns }